import IframeResizer from '@rio-cloud/iframe-resizer';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { useIntl } from 'react-intl';

import { useGetBookingForAccountQuery } from '#api/bookingApi.slice.ts';
import { useFeatureToggle } from '#configuration/featureFlags/useFeatureToggle.ts';
import { useGetTenant } from '#configuration/login/loginSlice.ts';
import { hasBookingState } from '#domain/bookingState.ts';
import { AppNavLink } from '#routes/AppNavLink.tsx';
import { routes } from '#routes/routes.ts';

import { config } from '../../config.ts';
import { ServiceInfoComponent } from '../shared/ServiceInfoComponent.tsx';

const AppHeader = () => {
    const intl = useIntl();
    const tenant = useGetTenant();
    const { data: bookingData } = useGetBookingForAccountQuery(undefined);
    const showOnlyTourServiceTours = useFeatureToggle('showOnlyTourServiceTours', false);

    const appTitle = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.appheader.app.title',
    });
    const orderTitle = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.appheader.orders.title',
    });
    const toursTitle = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.appheader.tours.title',
    });

    const userHasConfirmedBooking = hasBookingState(bookingData, 'CONFIRMED');
    const showNavItems = userHasConfirmedBooking && !showOnlyTourServiceTours;
    const navItems = showNavItems
        ? [
              {
                  key: routes.ORDERS,
                  route: (
                      <AppNavLink to={routes.ORDERS} trackingKey='ordercom.header.nav.orders'>
                          {orderTitle}
                      </AppNavLink>
                  ),
              },
              {
                  key: routes.TOURS,
                  route: (
                      <AppNavLink to={routes.TOURS} trackingKey='ordercom.header.nav.tours'>
                          {toursTitle}
                      </AppNavLink>
                  ),
              },
          ]
        : [];

    const environment = import.meta.env.PROD ? 'production' : 'local';

    const menuUrl = config.backend.MENU_SERVICE;
    const appNavigator = <IframeResizer title='Application navigator' className='iFrameResizer' src={menuUrl} />;

    const infoItem = <ServiceInfoComponent />;
    const chatItem = <OrderChat tenant={tenant} />;
    const notificationsItem = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;
    const actionBarItems = [infoItem, chatItem, notificationsItem, userMenuItem];

    const homeLink = (
        <a
            href={config.homeRoute}
            {...getTrackingAttributes({
                trigger: 'click',
                category: 'link autoTracking',
                action: 'link click',
                label: 'ordercom.header.nav.home',
            })}
        />
    );

    return (
        <ApplicationHeader
            appNavigator={appNavigator}
            label={appTitle}
            navItems={navItems}
            actionBarItems={actionBarItems}
            homeRoute={homeLink}
        />
    );
};

export default AppHeader;
